import React from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import UseAllAddressUser from '../../CustomHooks/User/UseAllAddressUser'
import UsePayCach from '../../CustomHooks/Cart/UsePayCach'
import { ToastContainer } from 'react-toastify'
import { Link } from 'react-router-dom'

const PaymentMethodComp = () => {
    const [alladdressList] = UseAllAddressUser()
    const [handleChangeAddress, handleCompleteOrder, TotalPrice, changePaymentMethod] = UsePayCach()

    return (
        <>
            {alladdressList && alladdressList.length >= 1 ? (
                <>
                    <Row>
                        <p className="fw-bold fs-30 dark-color"> Choose Payment Method </p>
                    </Row>
                    <Row className="d-flex justify-content-between">
                        <Col xs="12" className='mb-3'>
                            <input
                                onChange={changePaymentMethod}
                                name="group"
                                id="group1"
                                type="radio"
                                value="Visa"
                                className="mt-2"
                            />
                            <label className="mx-2" for="group1">
                                Visa
                            </label>
                        </Col>
                        <Col xs="12" className='mb-3'>
                            <input
                                onChange={changePaymentMethod}
                                name="group"
                                id="group2"
                                type="radio"
                                value="Cash"
                                className="mt-2"
                            />
                            <label className="mx-2" for="group2">
                                Cash on delivery
                            </label>
                        </Col>
                        <Col xs="12" className='d-flex h-60'>
                            <Form.Select aria-label="Default select example" className='form-control' onChange={handleChangeAddress}>
                                <option value="0">Choose Your Address</option>
                                {alladdressList ? alladdressList.map((item) => { return (<option key={item._id} value={item._id}>({item.alias}) : {item.details} </option>) }) : null}
                            </Form.Select>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs="12" className="mt-5 d-sm-flex d-xs-block justify-content-end align-items-center">
                            <p className="mb-sm-0 fw-bold me-3 fs-30 text-xs-center fs-xs-30">{TotalPrice} EGP</p>
                            <button className="px-5 py-3 w-xs-100 text-white border-0 d-inline orange-bg" onClick={handleCompleteOrder}>Complete Order</button>
                        </Col>
                    </Row></>
            ) : (<> <div className='d-flex justify-content-center align-items-center flex-column mh-100-exact'>
                <h3 className='alert alert-danger'>You Must Add Address, to complete your order</h3>
                <Link to="/user/add-address">
                    <Button className='dark-bg border-0 px-5 py-3'>Add Address</Button>
                </Link>
            </div></>)}
            <ToastContainer limit={3} />
        </>
    )
}

export default PaymentMethodComp
